namespace RioERP.Web.Enums {
    export enum PendingOrderStatus {
        Open = 1,
        AssignedToEnquiry = 2,
        Closed = 3
    }
    Serenity.Decorators.registerEnumType(PendingOrderStatus, 'RioERP.Web.Enums.PendingOrderStatus');
}
